import React from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import { InvestorStatementItem } from '../../../models/admin/InvestorStatement';

interface StatementSendEmailPromptProps {
  item: InvestorStatementItem;
  onDecline: () => void;
  onAccept: () => void;
}

const StatementSendEmailPrompt: React.FC<StatementSendEmailPromptProps> = ({
  item,
  onDecline,
  onAccept,
}) => (
  <Dialog open onClose={onDecline}>
    <DialogTitle>Send email now?</DialogTitle>
    <DialogContent>
      {item.investmentEntityName}&apos;s statement has been added to their investor documents. Would
      you like to email it to them now?
    </DialogContent>
    <DialogActions>
      <Button onClick={onDecline}>Not now</Button>
      <Button variant="contained" onClick={onAccept}>
        Send email
      </Button>
    </DialogActions>
  </Dialog>
);

export default StatementSendEmailPrompt;
